import { AddTagsRequest, CreateTagRequest, RemoveTagsRequest } from './types';
import { Tag } from 'features/common/types';
import { deleteData, getData, post, put } from 'services/api';

// Tags CRUD
export const getTags = async (): Promise<Tag[]> => {
	return getData('/tags');
};

export const getTagById = async (tagId: number): Promise<Tag> => {
	return getData(`/tags/${tagId}`);
};

export const createTag = async (data: CreateTagRequest): Promise<Tag> => {
	return post('/tags', data);
};

export const updateTag = async (tagId: number, data: Partial<CreateTagRequest>): Promise<Tag> => {
	return put(`/tags/${tagId}`, data);
};

export const deleteTag = async (tagId: number): Promise<void> => {
	return deleteData(`/tags/${tagId}`);
};

// Event tags
export const addTagsToEvent = async (eventId: string, data: AddTagsRequest): Promise<void> => {
	return post(`/events/${eventId}/tags`, data);
};

export const removeTagsFromEvent = async (eventId: string, data: RemoveTagsRequest): Promise<void> => {
	return deleteData(`/events/${eventId}/tags`, { data });
};

export const getEventsByTag = async (tagId: number): Promise<any[]> => {
	return getData(`/events/by-tag/${tagId}`);
};

// Ticket type tags
export const addTagsToTicketType = async (ticketTypeId: number, data: AddTagsRequest): Promise<void> => {
	return post(`/ticket_types/${ticketTypeId}/tags`, data);
};

export const removeTagsFromTicketType = async (ticketTypeId: number, data: RemoveTagsRequest): Promise<void> => {
	return deleteData(`/ticket_types/${ticketTypeId}/tags`, { data });
};

export const getTicketTypesByTag = async (tagId: number): Promise<any[]> => {
	return getData(`/ticket_types/by-tag/${tagId}`);
};
